import type {
    TanstackQueryOptions,
    TanstackSuspenseQueryOptions,
} from "@@/shared/hooks/use-tanstack-query";
import {
    useTanstackMultiQuery,
    useTanstackSingleQuery,
    useTanstackSingleSuspenseQuery,
} from "@@/shared/hooks/use-tanstack-query";
import type { ProviderId, Quote, QuoteId } from "@towni/common";

const useQuotes = (
    providerId: ProviderId | undefined,
    options?: TanstackQueryOptions<Quote[]>,
) =>
    useTanstackMultiQuery<Quote>(
        `/quotes/for-provider/${providerId}`,
        ["quotes", providerId],
        { enabled: !!providerId, ...(options ?? {}) },
    );

const useQuote = (
    quoteId: QuoteId | undefined,
    options: TanstackSuspenseQueryOptions<Quote> = {},
) =>
    useTanstackSingleSuspenseQuery<Quote>(
        `/quotes/${quoteId}`,
        ["quotes", quoteId],
        {
            disabled: !quoteId,
            ...options,
        },
    );

// const useProviderSuspenseQuery = (
//     providerIdOrSlug: ProviderIdOrSlug | undefined,
//     options: TanstackSuspenseQueryOptions<Provider> = {},
// ) => {
//     const _providerIdOrSlug = encodeURIComponent(providerIdOrSlug ?? "");
//     return useTanstackSingleSuspenseQuery<Provider>(
//         `/providers/${_providerIdOrSlug}`,
//         ["providers", providerIdOrSlug],
//         { ...options, disabled: !providerIdOrSlug },
//     );
// };

const useCustomerLatestQuote = (
    quoteId: QuoteId | undefined,
    options?: TanstackQueryOptions<Quote>,
) =>
    useTanstackSingleQuery<Quote>(
        `/quotes/${quoteId}/current`,
        ["quotes", quoteId, "current"],
        {
            enabled: !!quoteId,
            ...(options ?? {}),
        },
    );

export { useCustomerLatestQuote, useQuote, useQuotes };
